module.exports = __webpack_public_path__ + "img/u212.aee6eeba.jpg";